import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, createInvalidVendorSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productDimensions,
    sections: [
        createInvalidPartSection(),
        createInvalidVendorSection(),
        {
            sectionKey: "missingProductDimensions",
            sectionTitle: "Missing Dimension or Weight Values",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "partNumber",
                    label: "Part Number",
                    type: "text",
                    extractValue: (o) => (typeof o === "string" ? o : o?.partNo ?? o?.partNumber ?? null),
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                },
                {
                    key: "vendorCode",
                    label: "Vendor Code",
                    type: "text",
                    extractValue: (o) => (typeof o === "string" ? o : o?.code ?? o?.vendorCode ?? null),
                    modifyRow: (row, val) => ({...row, vendorCode: val}),
                },
                {
                    key: "length",
                    label: "Length",
                    type: "input",
                    textFieldProps: {type: 'number',},
                    modifyRow: (row, val) => ({...row, length: val}),
                },
                {
                    key: "width",
                    label: "Width",
                    type: "input",
                    textFieldProps: {type: 'number',},
                    modifyRow: (row, val) => ({...row, width: val}),
                },
                {
                    key: "height",
                    label: "Height",
                    type: "input",
                    textFieldProps: {type: 'number',},
                    modifyRow: (row, val) => ({...row, height: val}),
                },
                {
                    key: "weight",
                    label: "Weight",
                    type: "input",
                    textFieldProps: {type: 'number',},
                    modifyRow: (row, val) => ({...row, weight: val}),
                },
            ],
        },
    ],
};
